import PostsSection from './PostsSection';
import PostsSectionContainer from './PostsSection.container';

export default PostsSectionContainer(PostsSection);
